import React from 'react';
import { 
  CopywriteImg,
  ComplianceImg,
  ProofreadersImg,
  ReleaseImg,
  SeoImg,
  TechnicalImg,
} from './elements';
import { 
  PageWrapper,
  FlexDiv, 
  Text, 
  Container, 
} from '@Main/elements';
import { Margin, P } from '@helpers';

export const Stages = ({t}) => {
  return (
    <PageWrapper darkMode={false}>
        <Container paddingTop='99px' marginLeft='102px' paddingBottom='32px' marginRight='69px'>
          <Text width='657px' paddingBefforeText="45px">
            <h1>{t("Content production stages and checkup")}</h1>
            <p>
              {t("It is necessary that the content we produce is at the same high quality level as the Soft-FX products and solutions. Therefore, before being published or deployed, content of any format undergoes approval by several departments to exclude any errors and miscommunication.")}
            </p>
          </Text>
        </Container>
        <Container marginLeft='102px' paddingBottom='50px'>
          <FlexDiv>
            <Margin marginTop='37px' marginRight='50px'>
              <CopywriteImg/>
            </Margin>
            <Margin maxWidth='472px' marginRight="56px">
              <P weight='600' size='15px' height='30px'>{t("Content managers or copywriters")}</P>
              <P weight='400' size='15px' height='30px' marginTop='10px'>
                {t("A content manager or copywriter creates the necessary piece of content according to a technical assignment, following the requirements provided in this guide.")} 
              </P>
            </Margin>
          </FlexDiv>
        </Container>
        <Container marginLeft='102px' paddingBottom='50px'>
          <FlexDiv>
            <Margin marginTop='37px' marginRight='50px'>
              <TechnicalImg/>
            </Margin>
            <Margin maxWidth='472px' marginRight="56px">
              <P weight='600' size='15px' height='30px'>{t("Technical specialists")}</P>
              <P weight='400' size='15px' height='30px' marginTop='10px'>
                {t("Technical specialists in this case are any competent Soft-FX employee capable of approving the technical details provided in the content.")}
              </P>
            </Margin>
          </FlexDiv>
        </Container>
        <Container marginLeft='102px' paddingBottom='50px'>
          <FlexDiv>
            <Margin marginTop='37px' marginRight='50px'>
              <SeoImg/>
            </Margin>
            <Margin maxWidth='472px' marginRight="56px">
              <P weight='600' size='15px' height='30px'>{t("SEO")}</P>
              <P weight='400' size='15px' height='30px' marginTop='10px'>
                {t("Search engine optimization of text is necessary when the content needs to be indexed on the web.")}
              </P>
            </Margin>
          </FlexDiv>
        </Container>
        <Container marginLeft='102px' paddingBottom='50px'>
          <FlexDiv>
            <Margin marginTop='37px' marginRight='50px'>
              <ComplianceImg/>
            </Margin>
            <Margin maxWidth='472px' marginRight="56px">
              <P weight='600' size='15px' height='30px'>{t("Compliance")}</P>
              <P weight='400' size='15px' height='30px' marginTop='10px'>
                {t("All marketing materials produced must go through a Compliance sign off procedure, to ensure they are fit for purpose, ahead of being released or published.")}
              </P>
            </Margin>
          </FlexDiv>
        </Container>
        <Container marginLeft='102px' paddingBottom='50px'>
          <FlexDiv>
            <Margin marginTop='37px' marginRight='50px'>
              <ProofreadersImg/>
            </Margin>
            <Margin maxWidth='472px' marginRight="56px">
              <P weight='600' size='15px' height='30px'>{t("Proofreaders")}</P>
              <P weight='400' size='15px' height='30px' marginTop='10px'>
                {t("To ensure the correctness of the language used, all materials are reviewed by the native speakers.")}
              </P>
            </Margin>
          </FlexDiv>
        </Container>
        <Container marginLeft='102px' paddingBottom='122px'>
          <FlexDiv>
            <Margin marginTop='37px' marginRight='50px'>
              <ReleaseImg/>
            </Margin>
            <Margin maxWidth='472px' marginRight="56px">
              <P weight='600' size='15px' height='30px'>{t("Marketing lead approval and release")}</P>
              <P weight='400' size='15px' height='30px' marginTop='10px'>
                {t("After final approval by the marketing lead, the content moves on to be published on the designated platform.")}
              </P>
            </Margin>
          </FlexDiv>
        </Container>
     </PageWrapper>
  );
};